import { WarehouseOrDepotFragment, WarehouseOrDepotInput, WarehouseOrDepotInput__Kind } from '@admin/schema';

export function encodeWarehouseOrDepot(facility: { __typename?: string; id: string }): string {
  return `${facility.__typename}/${facility.id}`;
}

export function decodeWarehouseOrDepot(
  facilities: WarehouseOrDepotFragment[],
  encodedWarehouseOrDepot: string,
): WarehouseOrDepotFragment | undefined {
  return facilities.find((facility) => encodeWarehouseOrDepot(facility) === encodedWarehouseOrDepot);
}

export function encodedWarehouseOrDepotToInput(encodedWarehouseOrDepot: string): WarehouseOrDepotInput {
  return {
    id: encodedWarehouseOrDepot.split('/')[1],
    type:
      encodedWarehouseOrDepot.split('/')[0] === 'Warehouse'
        ? WarehouseOrDepotInput__Kind.Warehouse
        : WarehouseOrDepotInput__Kind.Depot,
  };
}

export function convertWarehouseOrDepotFragmentToWarehouseOrDepotInput(
  facilityFragment: WarehouseOrDepotFragment,
): WarehouseOrDepotInput {
  return {
    id: facilityFragment.id,
    type:
      facilityFragment.__typename === 'Warehouse'
        ? WarehouseOrDepotInput__Kind.Warehouse
        : WarehouseOrDepotInput__Kind.Depot,
  };
}

export function warehouseOrDepotNameWithType(facility: WarehouseOrDepotFragment) {
  return `${facility.name} (${facility.__typename})`;
}
